import { AppHelmet } from '@pendwa/common-browser/components/AppHelmet/index.js';
import { LayoutContainer } from '@pendwa/common-browser/components/LayoutContainer/index.js';
import { LayoutContainerNarrow } from '@pendwa/common-browser/components/LayoutContainerNarrow/index.js';
import { LayoutPageSection } from '@pendwa/common-browser/components/LayoutPageSection/index.js';
import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import { LoadingPage } from '@pendwa/common-browser/components/Loading/LoadingPage/index.js';
import { Footer } from '@pendwa/common-browser/components/Navs/Footer/index.js';
import { Nav } from '@pendwa/common-browser/components/Navs/Nav/index.js';
import { ContextPageData } from '@pendwa/common-browser/context/PageData/index.js';
import { redirectToPath } from '@pendwa/common-browser/core/appLocation/index.js';
import { getAbsoluteUrlToSite } from '@pendwa/common-browser/utils/getAbsoluteUrlToSite.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { LoginAuthCode } from '../../../../components/UserComponents/LoginAuthCode/index.js';
import { getFooterConfig } from '../../../../core/footer/config/index.js';
import { getNavConfig } from '../../../../core/nav/config/index.js';

export function Screen() {
  const history = useHistory();

  const handleSuccess = () => {
    redirectToPath(rootRoutes.app.status.paired.main.get(), false);
  };

  let $content: React.ReactNode = null;

  const { viewer, loading: loading_page_data } = React.useContext(ContextPageData);

  if (loading_page_data) {
    $content = (
      <LayoutSpacer>
        <LayoutSpacer>
          <img
            className="mx-auto h-24 w-auto"
            src={`https://res.cloudinary.com/pendwa/image/upload/w_512,h_512/public/assets/${DOMAIN_ENV}/logo/transparent-2560×2560.png`}
            alt={`${browserRootConfig.project.name} logo`}
          />
          <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Link A Device</h1>
        </LayoutSpacer>

        <LoadingPage />
      </LayoutSpacer>
    );
  } else if (!viewer) {
    $content = (
      <LayoutSpacer>
        <LayoutSpacer>
          <img
            className="mx-auto h-24 w-auto"
            src={`https://res.cloudinary.com/pendwa/image/upload/w_512,h_512/public/assets/${DOMAIN_ENV}/logo/transparent-2560×2560.png`}
            alt={`${browserRootConfig.project.name} logo`}
          />
          <h1 className="text-center text-3xl font-extrabold text-gray-900">Link A Device</h1>
        </LayoutSpacer>

        <div className="flex justify-center">
          <button
            type="button"
            className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
            onClick={() => history.push(rootRoutes.app.account.login.get(window.location.href))}
          >
            Sign In to Link Device
          </button>
        </div>
      </LayoutSpacer>
    );
  } else {
    $content = (
      <LayoutSpacer>
        <LayoutSpacer>
          <img
            className="mx-auto h-24 w-auto"
            src={`https://res.cloudinary.com/pendwa/image/upload/w_512,h_512/public/assets/${DOMAIN_ENV}/logo/transparent-2560×2560.png`}
            alt={`${browserRootConfig.project.name} logo`}
          />
          <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Link A Device</h1>
          <p className="mt-2 text-center text-base text-gray-600">Enter the code shown on your device.</p>
        </LayoutSpacer>

        <LoginAuthCode
          handleSuccess={() => {
            handleSuccess();
          }}
        />
      </LayoutSpacer>
    );
  }

  return (
    <React.Fragment>
      <AppHelmet
        title={`Pair A Device | ${browserRootConfig.project.name}`}
        description={`Link a device such as a TV to your Pendwa account.`}
        canonical_url={getAbsoluteUrlToSite(rootRoutes.app.pair.main.get())}
      />

      <Nav getConfig={getNavConfig} />

      <LayoutPageSection className="bg-gray-50">
        <LayoutContainerNarrow>{$content}</LayoutContainerNarrow>
      </LayoutPageSection>

      <LayoutPageSection>
        <LayoutContainer>
          <Footer getConfig={getFooterConfig} />
        </LayoutContainer>
      </LayoutPageSection>
    </React.Fragment>
  );
}
